import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getCustomer, SUPPORTED_CUSTOMERS } from "../../../MainPage/VersionInfo";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";
import { LIRR_SwitchTestsAndInspectionSections } from "./LIRR_SwitchTestsAndInspectionSchema";
import { ReasonAndCloseConfirmSection } from "../utils/ReasonAndCloseConfirmSection";
import SiteNotes from "../../utils/SiteNotes";
const { thirty_day, ninety_day_first, ninety_day_second } = LIRR_SwitchTestsAndInspectionSections;

const thirtyDayCode = ["LIRR_30DaySwitchObstructionTest"];
const ninetyDayCode = ["LIRR_90DaySwitchCircuitControllers"];

const masterKey = [
  {
    key: "C",
    value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance.",
  },
  {
    key: "A",
    value: "Adjustments made (identified in comments), test completed, and condition left in compliance.",
  },
  {
    key: "R",
    value: "Repairs and/or replacements made (identified in comments), test completed, and condition left in compliance.",
  },
  { key: "G", value: "Governed by special instruction" },
  {
    key: "NT",
    value: "The equipment was not tested in this inspection",
  },
  { key: "NC", value: "Not Compliant" },
  { key: "NA", value: "Test Not Applicable" },
];

const ReportView = (props) => {
  let { data } = props;
  const decodedData = Array.isArray(data.decodedData) ? data.decodedData : [];
  const thirtyDayData = decodedData.filter((t) => thirtyDayCode.includes(t.testCode));
  const ninetyDayData = decodedData.filter((t) => ninetyDayCode.includes(t.testCode));
  const reviewReqTests = props.reviewReqTests;
  const inspectionData = decodedData[0].inspectionData;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Test & Inspection Report" {...props} fontSizeOverride={"35px"} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} data={data} />
      <ReasonAndCloseConfirmSection inspectionData={inspectionData} isSwitch={true} />
      <span className="spacer"></span>
      {reviewReqTests.length > 0 && (
        <SiteNotes
          title={"Foreman/Supervisor Review"}
          testSchedule={reviewReqTests}
          updateTestSchedule={props.updateTestSchedule}
          allowedUsers={["manager", "supervisor"]}
          inspectionData={inspectionData}
          buttonTitle={"Add Review"}
        />
      )}
      <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
      <span className="spacer"></span>

      {renderTable(thirtyDayData, thirty_day, "30-Day – Switch Obstruction Test")}

      {renderTable(ninetyDayData, ninety_day_first, "90-Day – Switch Circuit Controllers/Point Detectors")}

      {renderTable(ninetyDayData, ninety_day_second)}
    </div>
  );
};

const LIRR_SwitchTestsAndInspectionReport = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView data={{}} />;
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUserAndInspection(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "LIRR_30DaySwitchObstructionTest",
    "LIRR_90DaySwitchCircuitControllers",
  ]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);
  let reportsWithReviewReq = ReportGroupingUtils.filterReviewRequestedGroups(reportsWithDecodedFormData, props.reportType);

  return reportsWithReviewReq.map((report, i) => {
    return <ReportView key={i} {...props} reviewReqTests={report.reviewReqTests} data={report} />;
  });
};

export default LIRR_SwitchTestsAndInspectionReport;

function renderTable(sectionData, sections, title) {
  return (
    sectionData.length > 0 &&
    sectionData.map((data) => {
      return (
        <div style={{ pageBreakInside: "avoid" }}>
          {title && <h2 style={{ textAlign: "center" }}>{title}</h2>}
          <table className="table-bordered" style={{ fontSize: "20px" }}>
            {sections.map((section) => {
              return <ReportTableSectionRenderer section={section} rowsData={data.summary} />;
            })}
          </table>
        </div>
      );
    })
  );
}



// WEBPACK FOOTER //
// ./src/components/Reports/LIRR/SwitchTestAndInspection/index.jsx